import { Card } from '@/components/ui/card'
import Dato from './Dato'
import { dinero, nombrePais } from './formato'

/** Pestaña «Resumen»: los datos de la empresa de un vistazo. */
export default function Resumen({ ficha }) {
  return (
    <Card className="p-4 sm:p-5">
      <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-5">
        <Dato label="Dueño">{ficha.dueño?.nombre}</Dato>
        <Dato label="Correo">{ficha.dueño?.email}</Dato>
        <Dato label="País">{nombrePais(ficha.pais)}</Dato>
        <Dato label="Giro">{ficha.giro}</Dato>
        <Dato label="Edición">{ficha.edicion}</Dato>
        <Dato label="Modalidad">{ficha.modalidad}</Dato>
        <Dato label="MRR">
          {ficha.mrr ? dinero(ficha.mrr, ficha.moneda)
            : ficha.precioPlan ? <>{dinero(ficha.precioPlan, ficha.moneda)} <span className="text-caption text-neutral-400 dark:text-neutral-500">(estimado)</span></>
            : '—'}
        </Dato>
        <Dato label="Tenant">{ficha.instancias?.[0]?.tenantId || '—'}</Dato>
        <Dato label="Negocios">{ficha.instancias?.length || 1}</Dato>
      </div>
    </Card>
  )
}
